import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api/technician-portal`

async function jsonOrThrow(response, fallback) {
  if (!response.ok) {
    const err = await response.json().catch(() => ({}))
    throw new Error(err.error || fallback)
  }
  return response.json()
}

export async function getMyTickets() {
  return jsonOrThrow(await fetch(`${API_BASE}/tickets`), 'No se pudieron cargar los tickets')
}

export async function getMyTicketDetail(ticketId) {
  return jsonOrThrow(await fetch(`${API_BASE}/tickets/${ticketId}`), 'No se pudo cargar el ticket')
}

// stage: CONFIRMED | EN_ROUTE | ON_SITE | RESOLVED. Para RESOLVED se envía la solución y, opcional, una foto.
export async function updateTicketStage(ticketId, stage, { solution = '', file = null } = {}) {
  const formData = new FormData()
  formData.append('stage', stage)
  if (solution) formData.append('solution', solution)
  if (file) formData.append('file', file)
  const response = await fetch(`${API_BASE}/tickets/${ticketId}/stage`, { method: 'PATCH', body: formData })
  return jsonOrThrow(response, 'No se pudo actualizar el estatus')
}

export async function sendTicketMessage(ticketId, text) {
  const formData = new FormData()
  formData.append('text', text)
  const response = await fetch(`${API_BASE}/tickets/${ticketId}/messages`, { method: 'POST', body: formData })
  return jsonOrThrow(response, 'No se pudo enviar el mensaje')
}

export const photoSrc = (filePath) => (filePath ? `${API_ORIGIN}/uploads/${filePath}` : '')

export const PRIORITY_INFO = {
  CRITICAL: { label: 'Crítica', color: '#e84545' },
  HIGH: { label: 'Alta', color: '#f0a500' },
  MEDIUM: { label: 'Media', color: '#3b82f6' },
  LOW: { label: 'Baja', color: '#94a3b8' },
}

export const STAGE_INFO = {
  CONFIRMED: { label: 'Confirmado', color: '#3b82f6' },
  EN_ROUTE: { label: 'En camino', color: '#f0a500' },
  ON_SITE: { label: 'En sitio', color: '#8b5cf6' },
  RESOLVED: { label: 'Resuelto', color: '#10b981' },
}

export const WAIT_REASONS = {
  PARTS: 'esperando refacciones',
  TENANT_APPROVAL: 'esperando aprobación del inquilino',
  EXTERNAL_VENDOR: 'esperando proveedor externo',
  OTHER: 'en pausa',
}

function span(minutes) {
  const abs = Math.abs(minutes)
  if (abs >= 1440) return `${Math.floor(abs / 1440)}d`
  if (abs >= 60) {
    const h = Math.floor(abs / 60)
    const m = abs % 60
    return m ? `${h}h ${m}min` : `${h}h`
  }
  return `${abs}min`
}

// Texto del indicador de SLA según su estado.
export function slaText(sla) {
  if (!sla || sla.state === 'none') return ''
  if (sla.state === 'overdue') return `SLA vencido hace ${span(sla.minutes)}`
  if (sla.state === 'warning') return `SLA: ${span(sla.minutes)}`
  return `SLA: ${span(sla.minutes)} restantes`
}

export const SLA_COLORS = { ok: '#047857', warning: '#d97706', overdue: '#dc2626' }

export function formatShortDateTime(value) {
  if (!value) return ''
  const d = new Date(value)
  const date = d.toLocaleDateString('es-MX', { day: 'numeric', month: 'short' }).replace('.', '')
  const time = d.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', hour12: false })
  return `${date}, ${time}`
}

// ---------- Calendario de mantenimiento preventivo ----------

export async function getMyCalendar(year, month) {
  return jsonOrThrow(await fetch(`${API_BASE}/calendar?year=${year}&month=${month}`), 'No se pudo cargar el calendario')
}

export async function getMyScheduledDetail(scheduledId) {
  return jsonOrThrow(await fetch(`${API_BASE}/calendar/${scheduledId}`), 'No se pudo cargar el mantenimiento')
}

export async function completeMyScheduled(scheduledId, { description, file = null }) {
  const formData = new FormData()
  formData.append('description', description)
  if (file) formData.append('file', file)
  const response = await fetch(`${API_BASE}/calendar/${scheduledId}/complete`, { method: 'POST', body: formData })
  return jsonOrThrow(response, 'No se pudo marcar como completado')
}

export const INFRA_LABELS = {
  ELECTRICAL: 'Eléctrico', HYDRAULIC: 'Hidráulico', HVAC: 'HVAC',
  FIRE_SYSTEMS: 'Contra incendios', COMMON_AREAS: 'Áreas comunes', OTHER: 'Otro',
}
export const FREQUENCY_LABELS = {
  WEEKLY: 'Semanal', BIWEEKLY: 'Quincenal', MONTHLY: 'Mensual', BIMONTHLY: 'Bimestral',
  QUARTERLY: 'Trimestral', SEMIANNUAL: 'Semestral', ANNUAL: 'Anual',
}
export const SCHEDULED_STATUS = {
  SCHEDULED: { label: 'Programado', color: '#64748b' },
  CONFIRMED: { label: 'Confirmado', color: '#3b82f6' },
  IN_PROGRESS: { label: 'En proceso', color: '#f0a500' },
  COMPLETED: { label: 'Completado', color: '#10b981' },
}

export function formatDuration(hours) {
  if (!hours) return ''
  return hours < 1 ? `${Math.round(hours * 60)} min` : `${hours} h`
}